export { useDisclosure } from '../../hooks/useDisclosure';
export { useToast } from '../../hooks/useToast';
export { useMediaQuery } from '../../hooks/useMediaQuery';

export function ChakraProvider({ children, theme: _theme, resetCSS: _resetCSS }) {
  return children;
}

export function extendTheme(theme) {
  return theme;
}

export {
  Box,
  Flex,
  Stack,
  HStack,
  VStack,
  Center,
  SimpleGrid,
  Grid,
  GridItem,
  Circle,
  Text,
  Heading,
  Divider,
  Image,
  Link,
  List,
  OrderedList,
  UnorderedList,
  ListItem,
  ListIcon,
  Icon,
  Spinner,
  Skeleton
} from './legacy-layout';

export {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCloseButton
} from './modal';

export { Menu, MenuButton, MenuList, MenuItem, MenuDivider } from './menu';

export {
  Input,
  Textarea,
  Select,
  FormControl,
  FormLabel,
  ButtonGroup,
  IconButton,
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  Progress,
  Tooltip,
  Tag,
  Badge,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  InputGroup,
  InputRightElement,
  InputLeftElement
} from './legacy-forms';
